import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { verifyPassword } from "../../validators/password-match.validator";

@Component({
    selector: "app-rayalina-register-form",
    templateUrl: "./register-form.component.html",
    styleUrls: ["./register-form.component.scss"],
})
export class RayalinaRegisterFormComponent {
    @Input() returnUrl: string | null = null;
    @Output() readonly success = new EventEmitter<void>();

    isShowPass = [false, false];
    formSubmitted = false;
    errorMessage: string | null = null;
    loading = false;

    registerForm = new FormGroup(
        {
            name: new FormControl<string | null>(null, [Validators.required]),
            email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
            phonePrimary: new FormControl<string | null>(null, [Validators.required]),
            password: new FormControl<string | null>(null, [
                Validators.required,
                Validators.minLength(6),
            ]),
            passwordConfirm: new FormControl<string | null>(null, [
                Validators.required,
                Validators.minLength(6),
            ]),
            acceptTerms: new FormControl<boolean>(false, [Validators.requiredTrue]),
        },
        { validators: [verifyPassword] },
    );

    /** Same options as E-tsena client: MG default, dial code separate, libphonenumber utils. */
    readonly intlTelOptions: Record<string, unknown> = {
        initialCountry: "mg",
        separateDialCode: true,
        loadUtils: () => import("intl-tel-input/build/js/utils.js" as any),
    };

    constructor(private readonly auth: AuthService) {}

    handleShowPass(index: number): void {
        this.isShowPass[index] = !this.isShowPass[index];
    }

    onSubmit(): void {
        this.errorMessage = null;
        this.formSubmitted = true;
        if (!this.registerForm.valid) {
            return;
        }
        const { name, email, phonePrimary, password, passwordConfirm } = this.registerForm.getRawValue();
        this.loading = true;
        this.auth
            .register({
                name: name!,
                email: email!,
                phonePrimary: String(phonePrimary ?? "").trim(),
                password: password!,
                passwordConfirm: passwordConfirm!,
            })
            .subscribe({
                next: () => {
                    this.loading = false;
                    if (this.success.observed) {
                        this.success.emit();
                        return;
                    }
                    this.auth.navigateAfterAuth(this.returnUrl);
                },
                error: (err) => {
                    this.loading = false;
                    this.errorMessage =
                        typeof err?.error === "string"
                            ? err.error
                            : "Inscription impossible. Vérifiez vos informations et la configuration de l’API.";
                },
            });
    }

    get name() {
        return this.registerForm.get("name");
    }
    get email() {
        return this.registerForm.get("email");
    }
    get phonePrimary() {
        return this.registerForm.get("phonePrimary");
    }
    get password() {
        return this.registerForm.get("password");
    }
    get passwordConfirm() {
        return this.registerForm.get("passwordConfirm");
    }
    get acceptTerms() {
        return this.registerForm.get("acceptTerms");
    }
}
